import { Routes, Route, Navigate } from 'react-router-dom';
import { getStoredSession } from '@estream/sdk-browser/react';

// Layout
import Layout from './components/Layout';

// Pages
import Dashboard from './pages/Dashboard';
import Topology from './pages/Topology';
import Circuits from './pages/Circuits';
import Governance from './pages/Governance';
import Settings from './pages/Settings';
import Login from './pages/Login';

export default function App() {
  const storedSession = getStoredSession();
  const isLoggedIn = storedSession !== null;

  // Protected route wrapper
  function ProtectedRoute({ children }: { children: React.ReactNode }) {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    return <>{children}</>;
  }

  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected routes */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="topology" element={<Topology />} />
        <Route path="circuits" element={<Circuits />} />
        <Route path="governance" element={<Governance />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
